<i18n>
{
	"en": {
		"order": "Order",
		"saveJson": "Save JSON",
		"cancel": "Cancel"
	},
	"no": {
		"order": "Ordre",
		"saveJson": "Lagre JSON",
		"cancel": "Avbryt"
	}
}
</i18n>
<template>
	<t-vertical-panel v-if="jsonObject">
		<div slot="header" class="order-details-header">
			<t-panel-header icon="undefined" :text="`${$t('order')} ${jsonObject.orderNumber ? jsonObject.orderNumber : ''}`"/>
			<div class="order-details-header-sub-label" v-text="`JSON`"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="hideOrderJson"
			/>
		</div>
		<div slot="sub-header" ref="subHeader" class="order-details-sub-header">
			<div class="buttons-with-text">
				<t-button
					:value="$t('saveJson')"
					appearance="minimal"
					type="bp"
					iconBefore="tick"
					@click="saveOrderJson"
				/>
				<t-button
					:value="$t('cancel')"
					appearance="minimal"
					type="bp"
					iconBefore="trash"
					intent="danger"
					@click="hideOrderJson"
				/>
				<div/>
			</div>
		</div>
		<div v-show="!jsonLoading" class="details-content">
			<t-json-editor
				:jsonObject="jsonObject"
				:isInvalid="!!errorMessage"
				:validationMessage="errorMessage"
				resize="none"
				height="100%"
				@change="jsonChanged"
			/>
		</div>
		<t-overlay
			:isShown="jsonLoading"
			absolute
			loader
		/>
	</t-vertical-panel>
</template>

<script>
import rdbClient from 'rdb-client';
import { throwTranslatableError } from '@/core';
import { getOrderByIdRequest, updateOrderRequest } from './requests';
import { validateSubOrders } from '@/modules/newOrder/validation/subOrders';
import { validateOrder } from '@/modules/newOrder/validation/order';
export default {
	name: 'EditOrderJson',
	components: { },
	props: { orderId: String },
	data() {
		return {
			errorMessage: null,
			jsonLoading: false,
			initialJsonObject: {},
			jsonObject: {},
			error: {}
		};
	},
	watch: {
		orderId: {
			async handler(val, oldVal) {
				if (!val || val === oldVal) return;
				this.jsonLoading = true;
				await this.getOrderJson(val);
				this.errorMessage = null;
				this.jsonLoading = false;
			},
			immediate: true
		}
	},
	methods: {
		hideOrderJson() {
			this.$emit('hide');
		},
		async saveOrderJson() {
			document.activeElement.blur();
			if (this.errorMessage) return;
			this.jsonLoading = true;
			try {
				await this.saveOrder();
				this.errorMessage = null;
				this.$emit('changed', this.jsonObject);
			} catch (e) {
				this.errorMessage = e.message;
				console.error(e);
			}
			this.jsonLoading = false;
		},
		jsonChanged(value) {
			let jsonValue;
			try {
				jsonValue = JSON.parse(value);
				this.setJsonObject(jsonValue);
				this.errorMessage = null;
			} catch (e) {
				this.errorMessage = e.message;
			}
		},

		// Actions
		async saveOrder() {
			this.validate();
			if (this.error.order.isInvalid || this.error.subOrders.isInvalid) {
				throw new Error('ValidationError');
			}
			let initialPatch = rdbClient.createPatch(this.initialJsonObject, this.jsonObject );
			try {
				let updatedOrder = await updateOrderRequest(this.initialJsonObject.id, { orderUpdates: initialPatch });
				this.setOrderJson(updatedOrder);
			} catch (e) {
				if (e.response && e.response.data && e.response.data && e.response.data.errors) {
					console.error(e.response.data.errors);
				}
				throwTranslatableError(e, 'failedToSave');
			}
		},
		async getOrderJson(orderId) {
			try {
				let response = await getOrderByIdRequest(orderId);
				this.setOrderJson(response);
			} catch (e) {
				console.error(e);
			}
		},
		setOrderJson(value) {
			this.setInitialJsonObject(value);
			this.setJsonObject(value);
		},

		// Mutations
		setInitialJsonObject(value) {
			if (!value) return;
			this.initialJsonObject = value;
		},
		setJsonObject(value) {
			if (!value) return;
			this.jsonObject = value;
		},
		validate() {
			this.error.order = validateOrder(this.jsonObject);
			if (this.jsonObject.subOrders && this.jsonObject.subOrders.length) {
				this.error.subOrders = validateSubOrders(this.jsonObject.subOrders);
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.order-details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 15px;
	.order-details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}

.order-details-sub-header {
	height: 100%;
	.buttons-with-text {
		display:grid;
		padding: 0px 10px;
		height: 100%;
		align-items: center;
		grid-template-columns: repeat(2, minmax(100px, max-content)) auto repeat(2, minmax(100px, max-content));
		grid-column-gap: 10px;
	}
	.buttons-no-text {
		display:grid;
		padding: 0px 10px;
		height: 100%;
		align-items: center;
		grid-template-columns: repeat(3, minmax(min-content, max-content)) auto repeat(3, minmax(min-content, max-content));
		grid-column-gap: 10px;
	}
}
.lowercase {
	text-transform: lowercase;
}

.details-content {
	min-height:100%;
	display: grid;
	background: white;
	// padding: 20px;
	row-gap: 20px;
	// grid-template-rows: repeat(2, minmax(min-content, max-content)) minmax(min-content, max-content);
}

</style>
